import styled, { css } from 'styled-components';

export const TileInner = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.5s;
  transform-style: preserve-3d;
`;

export const TileFront = styled.div<{ $color: string }>`
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: ${({ $color }) => $color};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const TileBack = styled.div<{ $color: string }>`
  display: flex;
  flex-direction: column;
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: ${({ $color }) => $color};
  color: white;
  justify-content: center;
  align-items: center;
  opacity: 0;
  > span {
    margin-left: 5px;
  }
`;

export const RatingTileContainer = styled.div<{ $zoomOnHover: boolean }>`
  perspective: 400px;
  width: 220px;
  height: 55px;
  margin-left: 1px;
  margin-top: 1px;
  flex-shrink: 0;
  transition: transform 0.2s ease-in-out;
  &:hover {
    ${TileBack} {
      opacity: 1;
    }

    ${({ $zoomOnHover }) =>
      $zoomOnHover &&
      css`
      ${TileInner} {
        box-shadow: 0 0 11px 0 rgba(0, 0, 0, 0.2);
      }
      z-index: 5;
      transform: scale(1.05);
      position: relative;
  }`}
`;
